/* eslint-disable require-jsdoc */
/* eslint-disable no-undef */
import { debug } from '../../../../config';
import {stylers} from './styles/stylers';

export function renderPopUpMap(popUp, mapEl, popUpData) {
  const loc = new google.maps.LatLng(popUp.MapCenter.lat, popUp.MapCenter.lng);
  // let testCenter = aMap.map.loc;
  const options = {
    scrollwheel: false,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: stylers.styles,
    center: loc,
    mapTypeControl: false,
    zoom: 12,
  };
  popUp.mapObj = new google.maps.Map(mapEl, options);
  const bounds = new google.maps.LatLngBounds();
  const mapMarker = new google.maps.Marker({
    position: loc,
    map: popUp.mapObj,
    zIndex: 2,
    icon: stylers.icons.hasnoeventsv6,
  });
  mapMarker.setMap(popUp.mapObj);
  bounds.extend(mapMarker.getPosition());
  // map.fitBounds(bounds);
  const data = {
    lat: parseFloat(mapEl.dataset.lat ? mapEl.dataset.lat : 0),
    lng: parseFloat(mapEl.dataset.lng ? mapEl.dataset.lng : 0),
    address: mapEl.dataset.address,
    title: mapEl.dataset.title ? mapEl.dataset.title : 'Map',
    image: popUpData.venueImage,
  };
  const popUpMarkerInfo = new google.maps.InfoWindow({
    content: markerTmpl(data),
  });
  debug && console.log(popUp.mapObj, mapMarker, popUpMarkerInfo);
  handleMarkerClick(popUp.mapObj, mapMarker, popUpMarkerInfo);
}
function handleMarkerClick(map, marker, infowindow) {
  infowindow.open(map, marker);
  map.addListener('click', () => {
    infowindow.close();
  });
  marker.addListener('click', () => {
    infowindow.open(map, marker);
  });
}

function markerTmpl(data) {
  const url = encodeURIComponent(data.address);
  const base_img_url = 'https://undrground-images.s3.amazonaws.com/';
  debug && console.log(data);
  const image_url = data.image;
  const infowindow_content = `
                            <div class="noevents-image"> <img src= '${
  data.image
}'onerror="this.style.display='none'"></div>`
  return `<article class="marker-box">
    <div class="marker-box__wrap">
      <div class="marker-box__grid">
        <div class="marker-box__main">
          <span class="marker-box__title">${data.title}</span>
          <address class="marker-box__address">
            <span class="marker-box__address">${data.address}</span>
          </address>
          ${infowindow_content}
          <a class="marker-box__btn btn-line" href="https://www.google.com/maps/place/${url}/"
          target="_blank">Get Directions</a>
        </div>
      </div>
    </div>
  </article>`;
}
